import React, { FC } from 'react'
import {
    FormSelect,
    FormSelectProps,
} from '@docpace/shared-react-components/FormSelect'
import { PracticeFileFragment } from '@docpace/shared-graphql/fragments'
import { useFormContext } from 'react-hook-form'

interface MuiFormPracticeFileSelectProps extends Omit<FormSelectProps, 'options'> {
    formController?: any
    practiceFiles: PracticeFileFragment[]
    label?: string
}

export const MuiFormPracticeFileSelect: FC<MuiFormPracticeFileSelectProps> = ({
    formController,
    practiceFiles,
    ...selectProps
}) => {
    const formContext = useFormContext()
    const {
        formState: { errors },
    } = formContext
    return (
        <FormSelect {...selectProps} options={[
            { value: '', label: 'none' },
            ...practiceFiles?.length > 0 ? practiceFiles.map(file=>({
                label: file?.title,
                value: file?.practiceFileId
            })): []
        ]} />
    )
}

export default MuiFormPracticeFileSelect
